/* eslint-disable */
/**
 * !!!!!!!! DO NOT MODIFY THIS FILE BY HAND !!!!!!!!
 * This file was automatically generated, and any changes made here will be overwritten.
 * @plugins/heft-editor-ui-module-extractor is used to extract this file from the src/index.ts by looking for EditorUIModule export. 
 * To add a module export const of type EditorUIModule and run "rush build" to regenerate this file.
 * 
 */
import { richTextModule } from '@editor/ui-richtext';
import { userModule } from '@editor/ui-user';
import { abTestingModule } from '@modules/ab-testing-editor-ui';
import { apiTeaserModule } from '@modules/api-teaser-editor-ui';
import { apiUserModule } from '@modules/api-user-editor-ui';
import { articleListModule } from '@modules/article-list-editor-ui';
import { articlePushModule } from '@modules/article-push-editor-ui';
import { articlesBoxModule } from '@modules/articles-box-editor-ui';
import { assemblerModule } from '@modules/assembler-editor-ui';
import { assemblerComponentsModule } from '@modules/assembler-editor-ui-components';
import { authorModule } from '@modules/author-editor-ui';
import { backgroundArticleModule } from '@modules/background-article-editor-ui';
import { catToolModule } from '@modules/cat-tool-editor-ui';
import { channelModule } from '@modules/channel-editor-ui';
import { channelComponentsModule } from '@modules/channel-editor-ui-components';
import { channelizerModule } from '@modules/channelizer-editor-ui';
import { ChipWidgetModule } from '@modules/chip-widget-editor-ui';
import { ctaButtonModule } from '@modules/cta-button-editor-ui';
import { cwcWidgetModule } from '@modules/cwc-widget-editor-ui';
import { entityPickerModule } from '@modules/entity-picker-editor-ui';
import { expertsCockpitModule } from '@modules/experts-cockpit-editor-ui';
import { finanzen100ChartWidgetModule } from '@modules/finanzen-100-chart-widget-editor-ui';
import { galleryModule } from '@modules/gallery-editor-ui';
import { hubPagesModule } from '@modules/hub-pages-editor-ui';
import { imageModule } from '@modules/image-editor-ui';
import { imageComponentsModule } from '@modules/image-editor-ui-components';
import { inpageWidgetModule } from '@modules/inpage-widget-editor-ui';
import { jobModule } from '@modules/job-editor-ui';
import { kimModule } from '@modules/kim-editor-ui';
import { linkoutTeaserModule } from '@modules/linkout-teaser-editor-ui';
import { linksBoxModule } from '@modules/links-box-editor-ui';
import { lockingModule } from '@modules/locking-editor-ui';
import { menuTreeModule } from '@modules/menu-tree-editor-ui';
import { movieModule } from '@modules/movie-editor-ui';
import { contentModule } from '@modules/news-article-editor-ui';
import { textContentBlockModule } from '@modules/news-article-editor-ui-article-content-text';
import { newsletterModule } from '@modules/newsletter-editor-ui';
import { partnerModule } from '@modules/partner-editor-ui';
import { partnerComponentsModule } from '@modules/partner-editor-ui-components';
import { recipeModule } from '@modules/recipe-editor-ui';
import { redirectModule } from '@modules/redirect-editor-ui';
import { reusableTextModule } from '@modules/reusable-text-editor-ui';
import { seoWhitelistModule } from '@modules/seo-whitelist-editor-ui';
import { socialModule } from '@modules/social-editor-ui';
import { sportHeuteWidget } from '@modules/sport-live-editor-ui';
import { staticPageModule } from '@modules/static-page-editor-ui';
import { tagsModule } from '@modules/tags-editor-ui';
import { testreportGeneratorModule } from '@modules/testreport-generator-editor-ui';
import { videoModule } from '@modules/video-editor-ui';
import { videoPageModule } from '@modules/video-page-editor-ui';

export const modules = [richTextModule, userModule, abTestingModule, apiTeaserModule, apiUserModule, articleListModule, articlePushModule, articlesBoxModule, assemblerModule, assemblerComponentsModule, authorModule, backgroundArticleModule, catToolModule, channelModule, channelComponentsModule, channelizerModule, ChipWidgetModule, ctaButtonModule, cwcWidgetModule, entityPickerModule, expertsCockpitModule, finanzen100ChartWidgetModule, galleryModule, hubPagesModule, imageModule, imageComponentsModule, inpageWidgetModule, jobModule, kimModule, linkoutTeaserModule, linksBoxModule, lockingModule, menuTreeModule, movieModule, contentModule, textContentBlockModule, newsletterModule, partnerModule, partnerComponentsModule, recipeModule, redirectModule, reusableTextModule, seoWhitelistModule, socialModule, sportHeuteWidget, staticPageModule, tagsModule, testreportGeneratorModule, videoModule, videoPageModule]; 
